(function () {
    'use strict';

    angular.module("imApp").factory("p2WebpageEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 13,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 15,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
